import React, { useState, useEffect } from 'react';
import { Modal as RNModal, View, Text, TextInput, TouchableOpacity, StyleSheet } from 'react-native';

interface ParentalGateModalProps {
  isVisible: boolean;
  onSuccess: () => void;
  onCancel: () => void;
}

const ParentalGateModal: React.FC<ParentalGateModalProps> = ({ isVisible, onSuccess, onCancel }) => {
  const [num1, setNum1] = useState(0);
  const [num2, setNum2] = useState(0);
  const [userInput, setUserInput] = useState('');

  useEffect(() => {
    if (isVisible) {
      const rand1 = Math.floor(Math.random() * 9) + 1;
      const rand2 = Math.floor(Math.random() * 9) + 1;
      setNum1(rand1);
      setNum2(rand2);
      setUserInput('');
    }
  }, [isVisible]);

  const handleSubmit = () => {
    const trimmed = userInput.trim();
    const answer = parseInt(trimmed, 10);
  
    if (!trimmed || isNaN(answer)) {
      alert('Please enter a number.');
      return;
    }
  
    if (answer === num1 * num2) {
      console.log('✅ Correct answer submitted. Proceeding...');
      onSuccess();
    } else {
      alert('Oops! Try again or ask a parent for help.');
      setUserInput('');
    }
  };
  

  if (!isVisible) return null;

  return (
    <RNModal transparent={true} visible={isVisible} animationType="fade">
      <View style={styles.overlay}>
        <View style={styles.container}>
          <Text style={styles.title}>Ask Your Parent For Help</Text>
          <Text style={styles.subtitle}>To continue, answer this:</Text>
          <Text style={styles.problem}>{`${num1} × ${num2} = ?`}</Text>

          <TextInput
            style={styles.input}
            value={userInput}
            onChangeText={setUserInput}
            keyboardType="numeric"
            placeholder="Your answer"
            autoFocus
            onSubmitEditing={handleSubmit}
            />
          <TouchableOpacity style={styles.submitBtn} onPress={handleSubmit}>
            <Text style={styles.submitText}>Submit</Text>
          </TouchableOpacity>

          <TouchableOpacity style={styles.cancelBtn} onPress={onCancel}>
            <Text style={styles.cancelText}>Cancel</Text>
          </TouchableOpacity>
        </View>
      </View>
    </RNModal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    flex: 1, backgroundColor: 'rgba(0,0,0,0.5)', justifyContent: 'center', alignItems: 'center'
  },
  container: {
    width: '90%', maxWidth: 400, backgroundColor: '#D9D9D9', borderRadius: 20, padding: 20, alignItems: 'center'
  },
  title: {
    fontSize: 18, fontWeight: 'bold', color: '#160014', marginBottom: 10
  },
  subtitle: {
    fontSize: 14, color: '#534466', marginBottom: 5
  },
  problem: {
    fontSize: 22, fontWeight: '600', marginVertical: 10
  },
  input: {
    borderWidth: 1, borderColor: '#544564', borderRadius: 10, width: '60%', padding: 10, textAlign: 'center', marginBottom: 20, backgroundColor: '#FFF'
  },
  submitBtn: {
    backgroundColor: '#544564', paddingVertical: 10, paddingHorizontal: 25, borderRadius: 10
  },
  submitText: {
    color: '#FFF', fontWeight: 'bold'
  },
  cancelBtn: {
    marginTop: 10
  },
  cancelText: {
    color: '#160014'
  }
});

export default ParentalGateModal;
